import { IClientValidator } from "./IClientValidator.js";
import { ValidatorBase } from "./validator-base.js";

/// Works with CheckGiftCardAddedAttribute.cs to perform unobtrusive validation in MVC against
/// the gift card input fields to ensure that if they are filled out, the customer has then validated
/// the gift card by clicking the button.
export class CheckGiftCardAdded extends ValidatorBase implements IClientValidator {
    public validate(value: string, element: HTMLInputElement, params: any): boolean {
        const checkboxElement = this.elementByName(params.giftcardcheckedproperty);
        const cardNumberElement = this.elementByName(params.giftcardnumberproperty);
        const verificationCodeElement = this.elementByName(params.giftcardverificationcodeproperty);
        const giftCardAddedElement = document.getElementById("GiftCardAdded") as HTMLInputElement;

        if (checkboxElement.checked && cardNumberElement.value && verificationCodeElement.value) {
            if (giftCardAddedElement?.value) {
                return true;
            }
            return false;
        }

        return true;
    }
}

window.validators = window.validators || {};
window.validators.checkgiftcardadded = new CheckGiftCardAdded();
